var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`aha-badge aha-badge-${_vm.size}`},[_vm._v("\n  "+_vm._s(_vm.label)+" "),(_vm.transferLicenseFrom)?_c('i',{staticClass:"fas fa-key ml-1"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }